
interface Params {
  isNovaPoshtaMode?: boolean;
  inStock: boolean;
  canPurchase?: boolean;
  addButtonTranslationKey?: string;
}

export  const getPurchaseButtonKey = ({
  isNovaPoshtaMode,
  inStock,
  canPurchase,
  addButtonTranslationKey,
}: Params) => {
  switch (true) {
    case (isNovaPoshtaMode && inStock): return 'np_products_unavailable';
    case (!inStock): return 'product_not_in_stock';
    case (!canPurchase): return 'product_unavailable';
    case (!!addButtonTranslationKey): return addButtonTranslationKey;
    default: return 'products.add.to-cart';
  }
};
